<template>
<div class="flex flex-row justify-between">
    <StyledButton
        :label="$t('label.cancel')"
        color="secondary"
        @click="$emit('cancel')">{{ $t('actions.cancel') }}</StyledButton>
    <StyledButton :label="$t('label.save')" @click="$emit('save')">{{ $t('actions.save') }}</StyledButton>
</div>
</template>

<script>
export default {
    props: {
        hideCancel: {
            type: Boolean,
            default: false
        },
        modal: {
            type: Boolean,
            default: false
        }
    },

    emits: ['save', 'cancel'],
};
</script>
